import React, { Component} from 'react'
import { Button, Modal } from 'react-bootstrap';
import { createHolidayRecord } from 'actions/UserActions';

const weekdays = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日",
]

class HolidayModal extends Component {
  state = {
    selectedWeekday: 0,
    loading: false
  }

  trySettingHoliday = () => {
    this.setState({
      loading: true
    })
    this.props.dispatch(createHolidayRecord(this.state.selectedWeekday))
      .then(() => this.props.dismiss())
      .catch(err => {
        alert("設定失敗!");
        this.setState({loading: false})
      });
  }

  onWeekdaySelected = (e) => {
    this.setState({selectedWeekday: e.target.value});
  } 

  render() {
    let { dismiss } = this.props;
    let { loading, selectedWeekday } = this.state;

    return (
      <Modal.Dialog>
        <Modal.Body>
          <div>
            <h3>
              設定本月假期
            </h3>
          </div>
          <form className="form">
            <select className="form-control" disabled={loading} value={selectedWeekday} onChange={this.onWeekdaySelected}>
              {weekdays.map((day, idx) => <option value={idx} key={day}>{day}</option>)}
            </select>
          </form>
          <Modal.Footer>
            <Button className="btn btn-primary" onClick={this.trySettingHoliday} disabled={loading}>設定</Button>
            <Button onClick={dismiss} disabled={loading}>關閉</Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal.Dialog>
    )
  }
}

export default HolidayModal;


// WEBPACK FOOTER //
// ./src/components/Worker/HolidayModal.js